import { indigo } from '@mui/material/colors';

/**
 * @type {import('@mui/material').ThemeOptions}
 */
const defaultTheme = {
  palette: {
    primary: {
      main: '#002854',
      contrastText: '#fff',
    },
    secondary: {
      main: '#007DFF',
    },
    red: {
      main: '#FF0000',
    },
    title: {
      main: indigo[900],
      contrastText: '#fff',
    },
    text: {
      title: 'rgb(112, 76, 182)',
      number: 'rgb(81,82,82)',
    },
  },
  typography: {
    fontFamily: 'Roboto, sans-serif',
  },
};

export default defaultTheme;
